import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Button, Stack, Stepper, Step, StepLabel, StepConnector, stepConnectorClasses, TextField, useMediaQuery, Box, FormControl, InputLabel, Select, MenuItem, useTheme, FormHelperText } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories } from '../../../redux/slice/categories.slice';
import { getSubcategories } from '../../../redux/slice/subcategories.slice';
import { addProduct, editProduct, getDetailsProducts, getProducts } from '../../../redux/slice/products.slice';
import Header from '../../../components/Header';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
  }),
  ...(ownerState.error && {
    border: '2px solid red',
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon, onClick, theme, error } = props;

  const icons = {
    1: <img src="/assets/images/icons/basicw.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
    2: <img src="/assets/images/icons/variant.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
    3: <img src="/assets/images/icons/tax.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active, error }} className={className} onClick={onClick}>
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  error: PropTypes.bool,
};

const steps = ['Basic Details', 'Variant', 'Tax & Warrenty Details'];

const validationSchemas =
  Yup.object({
    mainCategory: Yup.string().required("Please select category"),
    subCategory: Yup.string().required("Please select subcategory"),
    productName: Yup.string().required(),
    unitOfMeasurement: Yup.string().required(),
    productFor: Yup.string().required("Please select product for."),
    make: Yup.string().required(),
    specifiaction: Yup.string().required(),
    Desacription: Yup.string().required(),
    HSNcode: Yup.string().required(),
    taxdetails: Yup.string().required(),
    // Warrentry: Yup.string().required('Year is required'),
    Size: Yup.string().required(),
    Color: Yup.string().required(),
  });

const initialValues = {
  mainCategory: '',
  subCategory: '',
  productName: '',
  unitOfMeasurement: '',
  productFor: '',
  make: '',
  specifiaction: '',
  Desacription: '',
  HSNcode: '',
  taxdetails: '',
  Warrentry: '',
  Size: '',
  Color: ''
};

const errorBelongsToStep = (errorKey, stepIndex) => {
  if (stepIndex === 0) {
    return ['mainCategory', 'subCategory', 'productName', 'unitOfMeasurement', 'productFor'].includes(errorKey);
  }
  else if (stepIndex === 1) {
    return ['make', 'specifiaction', 'Desacription', 'Size', 'Color'].includes(errorKey);
  }
  else if (stepIndex === 2) {
    return ['HSNcode', 'taxdetails', 'Warrentry'].includes(errorKey);
  }
  return false;
}

export default function Product() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);
  const [stepsWithErrors, setStepsWithErrors] = React.useState([false, false, false]);
  const [filteredSubcategories, setFilteredSubcategories] = React.useState([]);
  const [msg, setMsg] = React.useState('');
  const dispatch = useDispatch();
  const { state } = useLocation();
  const id = state?._id;
  const isMobile = useMediaQuery('(max-width:500px)');

  React.useEffect(() => {
    dispatch(getCategories());
    dispatch(getSubcategories());
  }, [dispatch]);

  const categories = useSelector(state => state.categories.categories);
  const subcategories = useSelector(state => state.subcategories.subcategories);
  const isLastStep = activeStep === steps.length - 1;

  const handleNext = (values) => {
    if (!isLastStep) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {

      setTouchedSteps(steps.map(() => true));

      validateForm().then((formErrors) => {
        const newStepsWithErrors = [false, false, false];
        Object.keys(formErrors).forEach((errorKey) => {
          steps.forEach((_, stepIndex) => {
            if (errorBelongsToStep(errorKey, stepIndex)) {
              newStepsWithErrors[stepIndex] = true;
            }
          });
        });

        setStepsWithErrors(newStepsWithErrors);

        if (Object.keys(formErrors).length === 0) {
          const submissionValues = {
            ...values,
            Warrentry: values.Warrentry || defaultYear
          };

          if (id) {
            delete submissionValues.isActive;
            delete submissionValues.createdAt;
            delete submissionValues.updatedAt;
            dispatch(editProduct({ id: values?._id, ...submissionValues })).then(() => {
              dispatch(getProducts());
            });
          } else {
            dispatch(addProduct(submissionValues)).then(() => {
              dispatch(getProducts());
            });
          }
          navigate('/admin/list-of-product');
          setActiveStep(0);
          setStepsWithErrors([false, false, false]);
        } else {
          console.log("Form validation errors:", formErrors);

          setFieldTouched('mainCategory', true);
          setFieldTouched('subCategory', true);
          setFieldTouched('productName', true);
          setFieldTouched('unitOfMeasurement', true);
          setFieldTouched('productFor', true);
          setFieldTouched('make', true);
          setFieldTouched('specifiaction', true);
          setFieldTouched('Desacription', true);
          setFieldTouched('Size', true);
          setFieldTouched('Color', true);
          setFieldTouched('HSNcode', true);
          setFieldTouched('taxdetails', true);
          setFieldTouched('Warrentry', true);
        }
      });
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => {
    setActiveStep(step);
  };
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();

  const changeCategorySelect = async (cat_id, initialSubCategory = null) => {
    const filteredSubs = subcategories.filter(sub => sub.categoryName === cat_id);
    console.log("filteredSubs", filteredSubs);
    setFilteredSubcategories(filteredSubs);

    if (initialSubCategory) {
      setFieldValue("subCategory", initialSubCategory);
    } else {
      setFieldValue("subCategory", "");
    }
  };

  const getMeasurementLabel = (subCategoryId) => {
    const category = subcategories.find(sub => sub?._id === subCategoryId);
    setMsg(`${category ? ' (' + category.unit + ')' : ''}`);
  };

  const handleSubCategoryChange = (event) => {
    const selectedSubCategoryId = event.target.value;
    setFieldValue("subCategory", selectedSubCategoryId);
    getMeasurementLabel(selectedSubCategoryId);
  };

  const { handleSubmit, handleBlur, handleChange, values, touched, errors, setFieldValue, setValues, validateForm, setFieldTouched } = useFormik({
    initialValues,
    validationSchema: validationSchemas,
    onSubmit: handleNext,
  });
  React.useEffect(() => {
    if (values.mainCategory) {

      const filteredSubs = subcategories.filter(sub => sub.categoryName === values.mainCategory);
      setFilteredSubcategories(filteredSubs);
    }
  }, [subcategories, values.mainCategory]);


  React.useEffect(() => {
    if (id) {
      dispatch(getDetailsProducts(id)).then((response) => {
        if (response.payload && response.payload.products) {
          const productData = response.payload.products;
          const category = categories.find(cat => cat.categoryName?._id === productData.mainCategory);

          setValues({
            ...productData,
          });

          if (category) {
            changeCategorySelect(category?._id, productData.subCategory);
          }
        } else {
          console.error("Product details not found or invalid response structure.");
        }
      }).catch(error => {
        console.error("Error fetching product details:", error);
      });
    }
  }, [id, dispatch, categories]);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, index) => 2000 + index);
  const defaultYear = years.includes(currentYear) ? currentYear : years[0];
  const navigate = useNavigate()

  React.useEffect(() => {
    if (touchedSteps.some(touched => touched)) {
      validateForm().then((formErrors) => {
        const newStepsWithErrors = [false, false, false];

        Object.keys(formErrors).forEach((errorKey) => {
          steps.forEach((_, stepIndex) => {
            if (errorBelongsToStep(errorKey, stepIndex)) {
              newStepsWithErrors[stepIndex] = true;
            }
          });
        });

        setStepsWithErrors(newStepsWithErrors);
      });
    }
  }, [values, touchedSteps]);

  return (
    <Box m="2px">
      {id ? (
        <Header
          title="UPDATE PRODUCT"
          subtitle="Update Your Product Here"
        />
      ) : (
        <Header
          title="ADD PRODUCT"
          subtitle="Manage Your Product Here"
        />
      )}

      <form onSubmit={handleSubmit}>
        <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
          <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel StepIconComponent={(props) => (
                  <ColorlibStepIcon
                    {...props}
                    theme={theme}
                    icon={index + 1}
                    onClick={() => handleStep(index)}
                    error={touchedSteps[index] && stepsWithErrors[index]}
                  />
                )}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === 0 && (
            <>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
                }}
              >
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id="category-label" style={{ color: theme.palette.text.primary }}>Category :</InputLabel>
                  <Select
                    variant="filled"
                    name='mainCategory'
                    labelId="category-label"
                    id="mainCategory"
                    onChange={(event) => {
                      setFieldValue("mainCategory", event.target.value);
                      changeCategorySelect(event.target.value);
                    }}
                    sx={{ gridColumn: "span 2" }}
                    value={values.mainCategory}
                    onBlur={handleBlur}
                    error={!!touched.mainCategory && !!errors.mainCategory}
                  >
                    {categories?.map((category) => (
                      <MenuItem key={category?._id} value={category?._id} >
                        {category?.categoryName}
                      </MenuItem>
                    ))}
                  </Select>

                  {touched.mainCategory && errors.mainCategory && (
                    <FormHelperText error>{errors.mainCategory}</FormHelperText>
                  )}
                </FormControl>
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id="category-label" style={{ color: theme.palette.text.primary }}>Subcategory :</InputLabel>
                  <Select
                    variant="filled"
                    name="subCategory"
                    labelId="subcategory-label"
                    id="subCategory"
                    value={values.subCategory}
                    onChange={handleSubCategoryChange}
                    onBlur={handleBlur}
                    sx={{ gridColumn: "span 2" }}
                    error={!!touched.subCategory && !!errors.subCategory}
                  >
                    {filteredSubcategories?.map((subcategory) => (
                      <MenuItem key={subcategory?._id} value={subcategory?._id} >
                        {subcategory?.subCategoryName}
                      </MenuItem>
                    ))}
                  </Select>

                  {touched.subCategory && errors.subCategory && (
                    <FormHelperText error>{errors.subCategory}</FormHelperText>
                  )}

                </FormControl>
              </Box>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                }}
              >
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Product Name :"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.productName}
                    name="productName"
                    error={!!touched.productName && !!errors.productName}
                    helperText={touched.productName && errors.productName}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label={`Unit of Measurement :` + msg}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.unitOfMeasurement}
                    name="unitOfMeasurement"
                    error={!!touched.unitOfMeasurement && !!errors.unitOfMeasurement}
                    helperText={touched.unitOfMeasurement && errors.unitOfMeasurement}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>
                <TextField
                  margin="dense"
                  id="productFor"
                  name="productFor"
                  label="Product For :"
                  select
                  fullWidth
                  variant="filled"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.productFor}
                  error={touched.productFor && Boolean(errors.productFor)}
                  helperText={touched.productFor && errors.productFor}
                  InputLabelProps={{
                    style: {
                      color: theme.palette.text.primary
                    }
                  }}
                >
                  <MenuItem value="Purchase">Purchase</MenuItem>
                  <MenuItem value="Sell">Sell</MenuItem>
                </TextField>

              </Box>
            </>
          )}
          {activeStep === 1 && (
            <>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                }}
              >
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Make :"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.make}
                    name="make"
                    error={!!touched.make && !!errors.make}
                    helperText={touched.make && errors.make}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Specification : "
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.specifiaction}
                    name="specifiaction"
                    error={!!touched.specifiaction && !!errors.specifiaction}
                    helperText={touched.specifiaction && errors.specifiaction}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />

                </FormControl>
              </Box>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                }}
              >
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Size :"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.Size}
                    name="Size"
                    error={!!touched.Size && !!errors.Size}
                    helperText={touched.Size && errors.Size}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>

                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Color :"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.Color}
                    name="Color"
                    error={!!touched.Color && !!errors.Color}
                    helperText={touched.Color && errors.Color}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>
              </Box>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(1, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                }}
              >
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    id="Desacription"
                    label="Discription :"
                    multiline
                    defaultValue=""
                    variant="filled"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.Desacription}
                    name="Desacription"
                    rows={4}
                    error={!!touched.Desacription && !!errors.Desacription}
                    helperText={touched.Desacription && errors.Desacription}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>

              </Box>
            </>
          )}
          {activeStep === 2 && (
            <>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                }}
              >
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="HSN Code :"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.HSNcode}
                    name="HSNcode"
                    error={!!touched.HSNcode && !!errors.HSNcode}
                    helperText={touched.HSNcode && errors.HSNcode}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>
                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Tax Details :"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.taxdetails}
                    name="taxdetails"
                    error={!!touched.taxdetails && !!errors.taxdetails}
                    helperText={touched.taxdetails && errors.taxdetails}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                  />
                </FormControl>

                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id="warranty-year-label" style={{ color: theme.palette.text.primary }}>Warranty Year</InputLabel>
                  <Select
                    labelId="warranty-year-label"
                    id="Warrentry"

                    value={values.Warrentry || defaultYear}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="Warrentry"
                    error={!!touched.Warrentry && !!errors.Warrentry}
                    InputLabelProps={{
                      style: {
                        color: theme.palette.text.primary
                      }
                    }}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                        },
                      },
                    }}
                  >
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched.Warrentry && errors.Warrentry && (
                    <FormHelperText error>{errors.Warrentry}</FormHelperText>
                  )}
                </FormControl>
              </Box>
            </>
          )}
          <FormControl>
            <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
              <Button
                variant="contained"
                disabled={activeStep === 0}
                onClick={handleBack}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="button"
                onClick={() => handleNext(values)}
              >
                {isLastStep ? id ? 'Update' : 'Submit' : 'Next'}
              </Button>
            </Stack>
          </FormControl>
        </Stack>
      </form>

    </Box>
  );
}

